import { ConfigSession } from "../interfaces/Session";

export const mockSession: ConfigSession = {
	email: "",
	password: "",
	remember: false,
	isLogged: false,
};
